import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { FileText, Target, Headphones } from 'lucide-react';
export const WhatYouGet: React.FC = () => {
  const deliverables = [{
    icon: <FileText size={32} className="text-gold" data-id="element-187" />,
    title: 'Manual Visa Master PDF',
    description: 'El protocolo completo de 5 minutos. Léelo en tu celular en menos de 15 minutos antes de tu cita.',
    value: '$27'
  }, {
    icon: <Target size={32} className="text-gold" data-id="element-188" />,
    title: 'Script de las 7 Preguntas de Fuego',
    description: 'Los guiones exactos para responder sobre tu trabajo, ingresos y motivos de viaje sin activar sospechas.',
    value: '$17'
  }, {
    icon: <Headphones size={32} className="text-gold" data-id="element-189" />,
    title: 'Audio de Entrenamiento Inmersivo Track 2',
    description: 'Un simulacro real para calibrar tu tono de voz y tus tiempos de respuesta antes de entrar.',
    value: '$17'
  }];
  return <SectionWrapper className="bg-navy" data-id="element-190">
      <h2 className="text-3xl md:text-4xl font-bold text-gold mb-10 text-center" data-id="element-191">
        ¿Qué recibes exactamente cuando compras hoy?
      </h2>

      <div className="border-2 border-gold bg-gold/5 p-6 rounded-xl mb-12 text-center max-w-3xl mx-auto" data-id="element-192">
        <p className="text-lg md:text-xl text-white font-medium" data-id="element-193">
          <strong className="text-gold" data-id="element-194">ENTREGA INMEDIATA:</strong> Recibirás un
          email con tu PDF y tu Audio en menos de 5 minutos después de tu pago.
          Puedes leerlo desde tu celular ahora mismo.
        </p>
      </div>

      <div className="space-y-6 max-w-3xl mx-auto" data-id="element-195">
        {deliverables.map((item, index) => <div key={index} className="bg-navy-light rounded-xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start border border-gray-800 hover:border-gold/30 transition-colors" data-id="element-196">
            <div className="bg-navy p-4 rounded-lg shrink-0" data-id="element-197">{item.icon}</div>
            <div className="flex-1" data-id="element-198">
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-199">
                {item.title}
              </h3>
              <p className="text-lg text-gray-300 mb-4" data-id="element-200">{item.description}</p>
              <div className="inline-block bg-gold/10 border border-gold/30 text-gold font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-201">
                Valor: {item.value}
              </div>
            </div>
          </div>)}
      </div>

      {/* Total & Pricing Summary */}
      <div className="max-w-3xl mx-auto mt-10" data-id="element-202">
        <div className="h-px bg-gold/60 w-full mb-8" data-id="element-203"></div>
        <div className="text-center space-y-3" data-id="element-204">
          <p className="text-xl md:text-2xl font-bold text-gold" data-id="element-205">
            Valor total del paquete: $61
          </p>
          <p className="text-3xl md:text-4xl font-bold text-white" data-id="element-206">
            Precio de lanzamiento: $6.39
          </p>
          <p className="text-sm text-gray-400" data-id="element-207">Estás ahorrando $54.61 hoy</p>
        </div>
      </div>
    </SectionWrapper>;
};